import React from 'react'
import CurrentUserContextProvider from 'contexts/currentUserContext'
import AbilityContextProvider from 'contexts/abilityContext'
import Monitoring from 'pages/Formalities/components/Monitoring'

const FormalitiesMonitoring = (): JSX.Element => (
  <CurrentUserContextProvider>
    <AbilityContextProvider>
      <Monitoring />
    </AbilityContextProvider>
  </CurrentUserContextProvider>
)

export default FormalitiesMonitoring
